<template>
  <v-container
    fluid
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-domain
      </v-icon> Organization Details
    </h2>
    <v-col
      class="text-right"
    >
      <v-btn
        color="#FF3700"
        @click="showPartnerLinkForm = true"
      >
        <v-icon
          left
          dark
        >
          mdi-link-variant-plus
        </v-icon>
        Link Partner
      </v-btn>
    </v-col>
    <v-card
      color="#CFD8DC"
    >
      <v-container
        fluid
      >
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-card
              color="#eceff1"
              class="details-card"
            >
              <v-container
                fluid
              >
                <p class="my-p-style">
                  Name:-
                  <font class="font-my-style">
                    {{ organizationDetails.name }}
                  </font>
                </p>
                <p class="my-p-style">
                  Alias:-
                  <font class="font-my-style">
                    {{ organizationDetails.alias }}
                  </font>
                </p>
                <p class="my-p-style">
                  Type:-
                  <font class="font-my-style">
                    {{ organizationDetails.type }}
                  </font>
                </p>
                <p
                  v-if="!isAddressAvailable"
                  class="my-p-style"
                >
                  Address:-
                  <font class="font-my-style">
                    N/A
                  </font>
                </p>
                <div
                  v-if="isAddressAvailable"
                  class="my-p-style"
                >
                  <p class="my-p-style">
                    Address:-
                  </p>
                  <v-container class="ml-2 py-0">
                    <p class="address-style">
                      Street 1:- <font class="address-font-style">
                        {{ organizationDetails.address.line1 }}
                      </font>
                    </p>
                    <p class="address-style">
                      Street 2:- <font
                        v-if="organizationDetails.address.line2 !== null"
                        class="address-font-style"
                      >
                        {{ organizationDetails.address.line2 }}
                      </font>
                      <font
                        v-else
                        class="address-font-style"
                      >
                        N/A
                      </font>
                    </p>
                    <p class="address-style">
                      City:- <font class="address-font-style">
                        {{ organizationDetails.address.city }}
                      </font>
                    </p>
                    <p class="address-style">
                      State:- <font class="address-font-style">
                        {{ organizationDetails.address.state }}
                      </font>
                    </p>
                    <p class="address-style">
                      Country:- <font class="address-font-style">
                        {{ organizationDetails.address.country }}
                      </font>
                    </p>
                    <p class="address-style">
                      Postal Code:- <font class="address-font-style">
                        {{ organizationDetails.address.postal_code }}
                      </font>
                    </p>
                  </v-container>
                </div>
                <p class="my-p-style">
                  Phone Number:-
                  <font
                    v-if="organizationDetails.phone_number !== null"
                    class="font-my-style"
                  >
                    {{ organizationDetails.phone_number }}
                  </font>
                  <font
                    v-else
                    class="font-my-style"
                  >
                    N/A
                  </font>
                </p>
                <p class="my-p-style">
                  External Id:-
                  <font class="font-my-style">
                    {{ organizationDetails.external_id }}
                  </font>
                </p>
                <p class="my-p-style">
                  Created At:-
                  <font class="font-my-style">
                    {{ organizationDetails.created_at | convertStringToLocalDatetime }}
                  </font>
                </p>
                <p class="my-p-style">
                  Office Timezone:-
                  <font class="font-my-style">
                    {{ organizationDetails.office_timezone }}
                  </font>
                </p>
                <br>
                <p class="my-p-style">
                  Partners:-
                </p>
                <p
                  v-if="!isPartnerLinked"
                  class="no-partner-alert"
                >
                  No Partners Linked
                </p>
                <v-row v-if="isPartnerLinked">
                  <v-col
                    :cols="cardSizeChange"
                  >
                    <v-card
                      v-for="(item, index) in organizationLinkedPartners"
                      :key="'item'+ index"
                      color="#b0bfb4"
                      class="my-card-style"
                    >
                      <v-list
                        class="my-list-style"
                        two-line
                      >
                        <v-list-item-group>
                          <v-list-item class="my-list-item-style">
                            <v-row>
                              <v-col>
                                <v-list-item-content
                                  class="ml-1"
                                >
                                  <v-list-item-title>
                                    <strong class="partner-header">
                                      Partner Name: <span class="partner-details">{{ item.partner.name }}</span>
                                    </strong>
                                  </v-list-item-title>

                                  <v-list-item-subtitle>
                                    <strong class="partner-header">
                                      App Module: <span class="partner-module">{{ item.partner.app_module.name | appNameUpdate }}</span>
                                    </strong>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-col>
                              <v-col
                                class="my-btn-style"
                              >
                                <v-list-item-action>
                                  <v-btn
                                    elevation="1"
                                    fab
                                    x-small
                                    icon
                                    color="#C62828"
                                    @click="deletePartnerLink(index)"
                                  >
                                    <v-icon>mdi-trash-can</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <centre-spinner
            :loading="loading"
          />
          <link-organization-partners
            v-if="showPartnerLinkForm"
            @closed="showPartnerLinkForm = false"
            @partner-linked="fetchOrganizationLinkedPartners"
          />
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';
  import Constants from 'src/constants';
  import LinkOrganizationPartners from './LinkOrganizationPartners.vue';

  export default {
    name: 'OrganizationDetails',
    components: {
      'centre-spinner': spinner,
      'link-organization-partners': LinkOrganizationPartners,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      firstLetterCapital (val) {
        if (val) {
          return val[0].toUpperCase() + val.slice(1);
        }
      },
      appNameUpdate (name) {
        if (name === 'digital-signage') {
          return 'Digital Signage';
        } else if (name === 'swift-check-in') {
          return 'Swift Check-In';
        } else if (name === 'swift-check-in-projects') {
          return 'Swift Check-In Projects';
        } else {
          return 'N/A';
        }
      },
    },
    data () {
      return {
        loading: false,
        isAddressAvailable: false,
        showPartnerLinkForm: false,
      };
    },
    computed: {
      organizationDetails () {
        return this.$store.getters['organizations/getOrganizationDetails'];
      },
      cardSizeChange () {
        if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return 10;
        } else {
          return 12;
        }
      },
      organizationLinkedPartners () {
        return this.$store.getters['organizations/getOrganizationLinkedPartners'];
      },
      isPartnerLinked () {
        if (this.organizationLinkedPartners.length > 0) {
          return true;
        }
        return false;
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchOrganizationDetails();
      await this.fetchOrganizationLinkedPartners();
      this.loading = false;
    },
    methods: {
      async fetchOrganizationDetails () {
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationDetails', {
          organizationId: organizationlId,
        }).then(response => {
          if (this.organizationDetails.address !== null) {
            this.isAddressAvailable = true;
          } else {
            this.isAddressAvailable = false;
          };
        }).catch(() => {
          this.loading = false;
        });
      },
      async fetchOrganizationLinkedPartners () {
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationLinkedPartners', {
          organizationId: organizationlId,
        }).catch(() => {
          this.loading = false;
        });
      },
      deletePartnerLink () {
        this.$store.dispatch('alert/onAlert', {
          message: 'You are not authorized to perform this action, please contact your administrator.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
    },
  };
</script>
<style scoped>
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  margin-bottom: 5px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.address-style {
margin-bottom: 5px;
color: #546E7A;
}
.address-font-style {
  color: #37474F;
}
.my-status-style {
  font-weight: bold;
  font-size: 15px;
}
@media (max-width: 960px) {
  .title-style {
   margin-top: -20px;
  }
}
.details-card {
  border-left: 3px solid #FF3700 !important;
}
.start-time-style {
  font-size: 14px;
}
.days-list-style {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.my-btn-style {
  text-align: right;
  margin-right: 10px;
}
.v-list-item__action:first-child {
  margin-right: 0px;
}
.my-card-style {
  margin-top: 10px;
  margin-bottom: 0px;
}
.my-list-item-style {
  padding-right: 0px;
}
.my-list-style {
  padding-top: 0px;
  padding-bottom: 0px;
}
.partner-details {
  color: #FF3700;
  font-weight: bold;
  text-transform: capitalize;
}
.partner-header {
  color: #37474F;
  font-weight: bold;
}
.partner-module {
  color: #546E7A;
}
.no-partner-alert {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
</style>
